import type { CartItem } from "../../../store/Cart"
import type { StockLevel } from "./utils"

export type { CartItem }

export type Props = {
  suppliers?: any[]
  onBack: () => void
}

export type FilterState = {
  brands: string[]
  priceMin: number | null
  priceMax: number | null
  sort: string
  /** «Нөөцтэй» chip: anything with stock > 0. */
  inStockOnly: boolean
  /** Sidebar stock legend (Бэлэн / Цөөн / Дууссан); empty = all. */
  stockLevels: StockLevel[]
  /** «Урамшуулалтай» chip. */
  promoOnly: boolean
  /** A single promotion picked from the promotion strip / page. */
  promotionId: string | null
}

export const EMPTY_FILTERS: FilterState = {
  brands: [],
  priceMin: null,
  priceMax: null,
  sort: "name-asc",
  inStockOnly: false,
  stockLevels: [],
  promoOnly: false,
  promotionId: null,
}

export type FilterChip = {
  type: string
  value: string
  label: string
}

/** Cards per page: four across, three rows (canvas OrdB_Catalog «1-12 / 794»). */
export const GRID_PAGE_SIZE = 12
export const TABLE_PAGE_SIZES = [20, 50, 100]

export type SortOption = { value: string; label: string }

export const getSortOptions = (t: (key: string) => string): SortOption[] => [
  { value: "name-asc", label: t("order:productList.sort.nameAsc") },
  { value: "name-desc", label: t("order:productList.sort.nameDesc") },
  { value: "price-asc", label: t("order:productList.sort.priceAsc") },
  { value: "price-desc", label: t("order:productList.sort.priceDesc") },
  { value: "stock-desc", label: t("order:productList.sort.stockDesc") },
]

// Cart Drawer types
export type SupplierCartGroup = {
  supplierName: string
  items: CartItem[]
  totalAmount: number
  totalItems: number
}

export type CheckoutFormData = {
  receiverStaffId: string
  receiverBranchId: string
  senderNote: string
  senderAdditionalNote: string
  supplierOrders: {
    supplierId: string
    deliveryType: string
    deliveryDate: string
    deliveryCheck: string
  }[]
}
